import * as React from "react";

function Extend(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 22" fill="none" {...props}>
      <path
        d="M0 10.75C0 4.813 4.813 0 10.75 0c4.818 0 8.847 3.168 10.215 7.525a.75.75 0 01-.715.975h-2.5a.75.75 0 110-1.5h1.417c-1.434-3.243-4.647-5.5-8.417-5.5a9.25 9.25 0 000 18.5.75.75 0 010 1.5C4.813 21.5 0 16.687 0 10.75z"
        fill="#333"
      />
      <path
        d="M10.75 6a.75.75 0 01.75.75v3.69l1.78 1.78a.75.75 0 11-1.06 1.06l-2-2a.75.75 0 01-.22-.53v-4a.75.75 0 01.75-.75zM21.5 10.75a.75.75 0 00-1.5 0c0 .315-.014.626-.042.932a.75.75 0 101.494.136c.032-.352.048-.708.048-1.068zM20.757 14.86a.75.75 0 10-1.404-.528c-.139.37-.299.727-.478 1.072a.75.75 0 101.331.692c.207-.398.39-.81.55-1.235zM18.468 18.567a.75.75 0 10-1.099-1.02 9.494 9.494 0 01-.905.854.75.75 0 00.957 1.156c.37-.306.72-.637 1.047-.99zM15.062 21.04a.75.75 0 00-.624-1.364 8.88 8.88 0 01-.923.362.75.75 0 10.47 1.424c.368-.12.727-.262 1.077-.422z"
        fill="#333"
      />
    </svg>
  );
}

export default Extend;
